module.exports = __webpack_public_path__ + "c15db0eac90c0826a18e6880fc06347c.MP3";